export default function (entity, extra) {

    console.log('debugging :', 'component', '\'' + 'forces' + '\'',  '(ending)');
    console.log(extra);
    console.log('debugging :', 'entity', '\'' + entity.name + '\'');
    console.log(entity);
};
